import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import PageNotFound from "../pages/pagenotfound";
import PaymentPage from "../pages/pay";
import PaymentCompletion from "../pages/paymentCompletion";
import { ROUTE_TO_PAGE_NOT_FOUND, ROUTE_TO_PAY, ROUTE_TO_PAYMENT_COMPLETION } from "./constants";




const Routes: React.FC = (props) => {

    // const nav = (<NavBarWidget />);
    console.log('render', props);


    return (
        <React.Fragment>
            <Switch>

                <Route exact path={'/'} component={
                    (_: RouteComponentProps) => {

                        return (
                            <Redirect to={ROUTE_TO_PAGE_NOT_FOUND} />
                        )
                    }
                } />



                <Route exact path={ROUTE_TO_PAY} component={(prop: RouteComponentProps) => {

                    return (
                        <PaymentPage />
                    )
                }} />



                <Route exact path={ROUTE_TO_PAGE_NOT_FOUND} component={PageNotFound} />

                <Route exact path={ROUTE_TO_PAYMENT_COMPLETION} component={PaymentCompletion} />

                <Route path={'/'} component={(props: RouteComponentProps) => {

                    return (
                        <Redirect to={ROUTE_TO_PAGE_NOT_FOUND} />

                    )
                }} />





            </Switch>

        </React.Fragment>

    )
}

export default Routes;